export const linkCardsExtensionType = 'com.atlassian.confluence.link-cards';
export const linkCardsExtensionKey = 'cards';
export const linkCardsContentAnalyticSource = 'cardsExtension';
